import { useIsDateInFuture } from "./useIsDateInFuture";
import { useIsStartDateBeforeEndDate } from "./useIsStartDateBeforeEndDate";

export const useValidateIssueExpiryDates = (issueDate?: string, expiryDate?: string) => {
  const { isStartBeforeEnd, handleStartDateChange, handleEndDateChange } =
    useIsStartDateBeforeEndDate({
      defaultValues: {
        startDate: issueDate,
        endDate: expiryDate,
      },
    });

  const { isDateInFuture, handleDateChange } = useIsDateInFuture({
    date: expiryDate,
  });

  return {
    isIssueBeforeExpiry: isStartBeforeEnd,
    handleIssueDateChange: handleStartDateChange,
    handleExpiryDateChange: handleEndDateChange,
    isExpiryInFuture: isDateInFuture,
    handleFutureExpiryDateChange: handleDateChange,
  };
};
